import React, { useEffect, useState } from "react";
import { EditAdminProfile, ViewAdminDetails } from "../utils/Api/ApiCalls";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import EditAccount from "./EditAccount";

const Settings = () => {
  const currentUser = useRecoilValue(userState);
  const Navigate = useNavigate();
  const [detailData, setDetailedData] = useState({});
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [load, setLoad] = useState(false);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState([]);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  const RetrieveAdminProfileDetails = async () => {
    try {
      const response = await ViewAdminDetails(currentUser?.data?.info?.id);

      setDetailedData(response?.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  useEffect(() => {
    RetrieveAdminProfileDetails();
  }, []);

  const [editProfile, setEditProfile] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNum: "",
    address: "",
    DateOfBirth: "",
    avatar: null,
  });

  const OnHandleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const avatarFile = files[0];
      const url = URL.createObjectURL(avatarFile);
      setPreviewImageUrl(url);
      setEditProfile((prevProfile) => ({
        ...prevProfile,
        [name]: avatarFile,
      }));
    } else {
      setEditProfile((prevProfile) => ({
        ...prevProfile,
        [name]: value,
      }));
    }
  };

  const AdminProfileEdit = async (e) => {
    setLoad(true);
    e.preventDefault();
    try {
      const response = await EditAdminProfile(
        currentUser?.data?.info?.id,
        editProfile
      );
      setLoad(false);
      // return response;
      Swal.fire({
        icon: "success",
        title: "Profile Updated Successfully",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        Navigate("/admin-dashboard");
      });
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  //   const firstName = detailData?.fullname.split(' ')[0];
  //   const lastName = detailData?.fullname.split(' ')[1];

  const General = () => {
    return (
      <div class="col-lg-9">
        <section class="content-body p-xl-4">
          <form onSubmit={AdminProfileEdit}>
            <div class="row">
              <div class="col-lg-8">
                <div class="row gx-3">
                  <div class="col-6 mb-3">
                    <label class="form-label">First name</label>
                    <input
                      // defaultValue={detailData?.fullname?.split(' ')[0]}
                      defaultValue={detailData?.profile?.firstName}
                      name="firstName"
                      class="form-control"
                      type="text"
                      placeholder="Type here"
                      onChange={OnHandleChange}
                    />
                  </div>

                  <div class="col-6 mb-3">
                    <label class="form-label">Last name</label>
                    <input
                      name="lastName"
                      class="form-control"
                      type="text"
                      placeholder="Type here"
                      onChange={OnHandleChange}
                      // defaultValue={detailData?.fullname?.split(' ')[1]}
                      defaultValue={detailData?.profile?.lastName}
                    />
                  </div>

                  <div class="col-lg-6 mb-3">
                    <label class="form-label">Email</label>
                    <input
                      name="email"
                      disabled
                      class="form-control"
                      type="email"
                      placeholder="example@mail.com"
                      onChange={OnHandleChange}
                      defaultValue={detailData?.email}
                    />
                  </div>

                  <div class="col-lg-6 mb-3">
                    <label class="form-label">Phone</label>
                    <input
                      name="phoneNum"
                      class="form-control"
                      type="tel"
                      placeholder="+2347012345678"
                      onChange={OnHandleChange}
                      defaultValue={detailData?.phoneNum}
                    />
                  </div>

                  <div class="col-lg-12 mb-3">
                    <label class="form-label">Address</label>
                    <input
                      name="address"
                      class="form-control"
                      type="text"
                      placeholder="Type here"
                      onChange={OnHandleChange}
                      defaultValue={detailData?.profile?.address}
                    />
                  </div>

                  <div class="col-lg-6 mb-3">
                    <label class="form-label">Birthday</label>
                    <input
                      name="DateOfBirth"
                      class="form-control"
                      type="date"
                      onChange={OnHandleChange}
                      defaultValue={detailData?.profile?.DateOfBirth}
                    />
                  </div>
                </div>
              </div>

              <aside class="col-lg-4">
                <figure class="text-lg-center">
                  {previewImageUrl !== null ? (
                    <img
                      class="img-lg mb-3 img-avatar"
                      src={previewImageUrl}
                      alt="User Photo"
                    />
                  ) : (
                    <img
                      class="img-lg mb-3 img-avatar"
                      // src={
                      //   detailData?.profile?.avatar !== ""
                      //     ? `http://localhost:7045/api/v1/uploads/${detailData?.profile?.avatar}`
                      //     : "assets/imgs/people/avatar-1.png"
                      // }
                      // src={`http://localhost:7045/uploads/${detailData?.profile?.avatar}`}
                      src={`https://backend.argone.ng/uploads/${detailData?.profile?.avatar}`}
                      alt="User Photo"
                    />
                  )}

                  <figcaption>
                    <input
                      name="avatar"
                      id="pix"
                      onChange={OnHandleChange}
                      style={{ display: "none" }}
                      type="file"
                    />
                    <label htmlFor="pix" class="btn btn-light rounded font-md">
                      <i class="icons material-icons md-backup font-md"></i>
                      Upload
                    </label>
                  </figcaption>
                </figure>
              </aside>
            </div>

            <br />
            {load ? (
              <button
                disabled
                style={{
                  background: "silver",
                }}
                class="btn btn-primary"
                type="submit"
              >
                Loading...
              </button>
            ) : (
              <button class="btn btn-primary" type="submit">
                Save changes
              </button>
            )}
          </form>
          <hr class="my-5" />
        </section>
      </div>
    );
  };
  return (
    <section class="content-main">
      <div class="content-header">
        <h2 class="content-title">Profile setting</h2>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row gx-5">
            <aside class="col-lg-3 border-end">
              <nav class="nav nav-pills flex-lg-column mb-4">
                <div
                  class={
                    activeTab === "/settings" ? "nav-link active" : "nav-link"
                  }
                  aria-current="page"
                  onClick={() => setActiveTab('/settings')}
                >
                  General
                </div>

                <div
                  class={
                    activeTab === "/edit-account"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  onClick={() => setActiveTab('/edit-account')}
                >
                  Account settings
                </div>
              </nav>
            </aside>
            {activeTab === "/settings" ? (<General />) : ''}
            {activeTab === "/edit-account" ? (<EditAccount />) : ''}

          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
